import React from "react";
import { observer } from "mobx-react";
import { AssociatedDocumentEditionViewStore } from "../../store";
import { AssociatedDocumentEditionViewForm } from "./AssociatedDocumentEditionViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type AssociatedDocumentEditionViewProps = {
  associatedDocumentEditionViewStore: AssociatedDocumentEditionViewStore;
};

export const AssociatedDocumentEditionView: React.FC<AssociatedDocumentEditionViewProps> =
  observer(({ associatedDocumentEditionViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <AssociatedDocumentEditionViewForm
          name={associatedDocumentEditionViewStore.nameValue}
          fileFiles={associatedDocumentEditionViewStore.fileFiles}
          typeValue={associatedDocumentEditionViewStore.typeValue}
          notes={associatedDocumentEditionViewStore.notesValue}
          publisherConfigurationDisplay={
            associatedDocumentEditionViewStore.publisherConfigurationDisplayValue
          }
          authorsDisplay={
            associatedDocumentEditionViewStore.authorsDisplayValue
          }
          onPrint={(handlePrint: () => void) =>
            associatedDocumentEditionViewStore.printAssociatedDocumentEdition(
              handlePrint
            )
          }
          onCancel={() =>
            associatedDocumentEditionViewStore.cancelAssociatedDocumentEdition()
          }
          onEdit={
            associatedDocumentEditionViewStore.isEditEnabled
              ? () =>
                  associatedDocumentEditionViewStore.editAssociatedDocumentEdition()
              : undefined
          }
          fileViewAction={getViewAction(
            (props) =>
              associatedDocumentEditionViewStore.fileDownload(props, "file"),
            (props) =>
              associatedDocumentEditionViewStore.viewFilePdf(props, "file")
          )}
        />
        <ErrorDialog
          open={associatedDocumentEditionViewStore.errorDialogOpened}
          title={associatedDocumentEditionViewStore.errorTitle}
          description={associatedDocumentEditionViewStore.errorDescription}
          onClose={() => associatedDocumentEditionViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={associatedDocumentEditionViewStore.pdfViewerOpen}
          onClose={() => associatedDocumentEditionViewStore.closePdfViewer()}
          pdfUrl={associatedDocumentEditionViewStore.pdfViewerUrl}
          title={associatedDocumentEditionViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
